export default "__VITE_ASSET__Bm2zYn9V__"